<div class="auth-error">
  <app-st-icon name="error" color="#CB2A2F" [filled]="true"></app-st-icon>
  <h1 class="text-header-24">No se pudo cargar tu usuario</h1>
  <p class="text-copy-14">
    Has iniciado sesión, pero no hemos podido obtener tus datos de Sourtrack.
    Vuelve a intentarlo y, si el problema continúa, contacta con el administrador.
  </p>
  <div class="actions">
    <button nz-button nzType="primary" (click)="retry()">Reintentar</button>
    <button nz-button (click)="logout()">Cerrar sesión</button>
  </div>
</div>
